import { Dialog, DialogActions, Box, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material'
import DeleteIcon from "../../../assets/setting/mycompany/invoces/Delete.png";

const LocationDeleteModal = (props:any) => {
    const { showDeleteModal, setShowDeleteModal } = props;

    return (
        <div>
            <Dialog  open={showDeleteModal} onClose={() => showDeleteModal(false)} fullWidth maxWidth="xs">
                <DialogTitle >
                    <Box display="flex" justifyContent="center">
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "50%", width: "60px", height: "60px", background: "#FF4D4F" }}>
                            <img src={DeleteIcon} alt="" />
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                            <Typography className='h4 fw-700 ' sx={{ pt: .5 }}>Are you sure?</Typography>
                            <Typography sx={{ pt: 2, pb: 1 }} className='h5 fw-500'>Do you want to delete department?</Typography>
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ pr: "30px", pb: 3 }}>
                    <button className=' btn-danger-color text-color btn-light-grey' onClick={() => setShowDeleteModal(!showDeleteModal)}>Cancel</button>
                    <button className='btn-delete-button btn-danger-color' onClick={() => setShowDeleteModal(!showDeleteModal)}>Delete</button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default LocationDeleteModal